/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy API
 * API for Pharmacy
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import promiseRetry from "promise-retry";
import { forceRefreshAccessToken } from "@mgdx-libs/firebase";
import * as runtime from "../runtime";
import {
  PostAIAssistantReceptionQRCodeRequestBody,
  PostAIAssistantReceptionQRCodeRequestBodyFromJSON,
  PostAIAssistantReceptionQRCodeRequestBodyToJSON,
  PostAIAssistantReceptionQRCodeResponse,
  PostAIAssistantReceptionQRCodeResponseFromJSON,
  PostAIAssistantReceptionQRCodeResponseToJSON,
} from "../models";

export interface CreateAiAssistantReceptionQrCodeRequest {
  postAIAssistantReceptionQRCodeRequestBody: PostAIAssistantReceptionQRCodeRequestBody;
}

/**
 *
 */
export class AiAssistantReceptionApi extends runtime.BaseAPI {
  /**
   * Create AI assistant reception QR code for AI assistant unattended check-in system
   */
  async createAiAssistantReceptionQrCodeRaw(
    requestParameters: CreateAiAssistantReceptionQrCodeRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<PostAIAssistantReceptionQRCodeResponse>> {
    if (
      requestParameters.postAIAssistantReceptionQRCodeRequestBody === null ||
      requestParameters.postAIAssistantReceptionQRCodeRequestBody === undefined
    ) {
      throw new runtime.RequiredError(
        "postAIAssistantReceptionQRCodeRequestBody",
        "Required parameter requestParameters.postAIAssistantReceptionQRCodeRequestBody was null or undefined when calling createAiAssistantReceptionQrCode."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/ai-assistant-reception-qr-code`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: PostAIAssistantReceptionQRCodeRequestBodyToJSON(
          requestParameters.postAIAssistantReceptionQRCodeRequestBody
        ),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PostAIAssistantReceptionQRCodeResponseFromJSON(jsonValue)
    );
  }

  /**
   * Create AI assistant reception QR code for AI assistant unattended check-in system
   */
  async createAiAssistantReceptionQrCode(
    requestParameters: CreateAiAssistantReceptionQrCodeRequest,
    initOverrides?: RequestInit
  ): Promise<PostAIAssistantReceptionQRCodeResponse> {
    return promiseRetry(
      (retry) =>
        this.createAiAssistantReceptionQrCodeRaw(requestParameters, initOverrides)
          .catch(async (error: Response) => {
            if (error.status === 401) {
              const accessToken = await forceRefreshAccessToken();
              if (accessToken) {
                retry(error);
              }
            }
            throw error;
          })
          .then(async (response) => {
            return await (response as any).value();
          }),
      {
        // The maximum amount of times to retry the operation. Default is 10.
        retries: 5,
        // The exponential factor to use. Default is 2.
        factor: 4,
        // The number of milliseconds before starting the first retry. Default is 1000.
        // minTimeout: 1000,
        // The maximum number of milliseconds between two retries. Default is Infinity.
        // maxTimeout: 60000,
        // Randomizes the timeouts by multiplying with a factor between 1 to 2. Default is false.
        // randomize: false,
      }
    ).catch((error) => {
      throw error;
    });
  }
}
